import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid2, Divider } from '@mui/material'

import CustomButton from '@components/button/customButton';
import CustomTextField from '@components/inputs/customTextField';

export default function ViewQuestionDialog({
  open,
  onClose,
  selectedQuestion,
}) {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
      fullWidth
    >
      <DialogTitle id="alert-dialog-title" fontSize={"0.9rem"} fontWeight={600} color='#202020' sx={{padding: '20px 25px'}}>
        View Question
      </DialogTitle>
      <DialogContent sx={{padding: '0px 25px', overflow: 'visible'}}>
        <Grid2 container spacing={"20px"}>
          <Grid2 size={12}>
            <Typography fontSize={"0.8rem"} fontWeight={600} color='#5D5D5D'>Question Details</Typography>
          </Grid2>
          <Grid2 size={12}>
            <CustomTextField 
              label='Question'
              value={selectedQuestion?.questionEng}
              readOnly
            />
          </Grid2>
          <Grid2 size={12}>
            <CustomTextField 
              label='Question Type'
              value={selectedQuestion?.questionType?.valueEng}
              readOnly
            />
          </Grid2>
          <Grid2 size={{lg: 6, xs: 12}}>
            <CustomTextField 
              label='Total Choice'
              value={selectedQuestion?.questionOptions?.length > 0 ? selectedQuestion?.questionOptions?.length : "-"}
              readOnly
            />
          </Grid2>
          <Grid2 size={{lg: 6, xs: 12}}>
            <CustomTextField 
              label='Max Allowed'
              value={selectedQuestion?.maxAllowed || "-"}
              readOnly
            />
          </Grid2>
          {selectedQuestion?.questionOptions?.length > 0 && 
          <>
            <Grid2 size={12}>
              <Divider />
            </Grid2>
            <Grid2 size={12}>
              <Typography fontSize={"0.8rem"} fontWeight={600} color='#5D5D5D'>Choice(s)</Typography>
            </Grid2>
            {selectedQuestion?.questionOptions.map((data, index) => (
              <React.Fragment key={index}>
                <Grid2 size={{lg: 8, xs: 12}}>
                  <CustomTextField 
                    label='Option Text'
                    value={data?.optionEng}
                    readOnly
                  />
                </Grid2>
                <Grid2 size={{lg: 4, xs: 12}}>
                  <CustomTextField 
                    label='Sub Textbox'
                    value={data?.subText ? "Yes" : "No"}
                    readOnly
                  />
                </Grid2>
              </React.Fragment>
            ))}
          </>
          }
          
        </Grid2>
      </DialogContent>
      <DialogActions sx={{padding: '20px 25px'}}>
        <CustomButton color='#999999' onClick={onClose}>
          Close
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}